/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';
import '@splidejs/splide/css/core';


//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//


var Webfont = require("webfontloader");

Webfont.load({
    google: {
        families: ["Raleway:300,400,500,600,800"]
    },
});


//--------------------------------------------------------------------//


// Libreria Lazysizeså
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import smoothScroll from './utilities/smooth-scroll';
import { animation } from 'components/animation/animation';
import videoPlayer from 'components/video-player/video-player';

//--------------------------------------------------------------------//

// Init Utilies
//--------------------------------------------------------------------//

smoothScroll();
animation();
//--------------------------------------------------------------------//


// Import Componenti
//--------------------------------------------------------------------//

import header from 'components/header/header';
import footer from 'components/footer/footer';
import accordion from 'components/accordion/accordion';
import breadcrumb from 'components/breadcrumb/breadcrumb'; 

//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

header();
accordion();


//--------------------------------------------------------------------//